import ConsultantNotesView from "./ConsultantNotesView";
export default ConsultantNotesView